// ----------------------------------------------------------------------------
// Section: Product Slider
// ----------------------------------------------------------------------------
//
// This is a section that displays product slider items and optional button
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------
import Swiper, { Navigation, Scrollbar, A11y, Keyboard } from 'swiper';
import 'snippets/card/card';
import 'snippets/icon/icon';

// Style includes
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/scrollbar';
import 'swiper/css/a11y';
import 'swiper/css/keyboard';
import './_product-slider.scss';

// -------------------------------------
// Variables
// -------------------------------------

// Selectors
const PRODUCT_SLIDER_SELECTOR = '.carousel--product-slider-container';
const CAROUSEL_SELECTOR        = '.carousel--product-slider';
const PREV_BUTTON_SELECTOR     = '.product-slider-button-prev';
const NEXT_BUTTON_SELECTOR     = '.product-slider-button-next';
const SCROLLBAR_SELECTOR       = '.swiper-scrollbar';

// -------------------------------------
// Helpers
// -------------------------------------

const initProductCarousel = (productSlider) => {
    const carousel   = productSlider.querySelector(CAROUSEL_SELECTOR)
    const prevButton = productSlider.querySelector(PREV_BUTTON_SELECTOR);
    const nextButton = productSlider.querySelector(NEXT_BUTTON_SELECTOR);
    const scrollbar  = productSlider.querySelector(SCROLLBAR_SELECTOR);

    const swiper = new Swiper(carousel, {
        modules: [Navigation, Scrollbar, A11y, Keyboard],
        slidesPerView: 1.4,
        spaceBetween: 10,
        centerInsufficientSlides: true,
        observer: true,
        observeParents: true,
        a11y: false,
        watchOverflow: true, // Do not turn into sliders if number of slides is less than slidesPerView.
        grabCursor: true,

        breakpoints: {
            680: {
                slidesPerView: 2.5,
                spaceBetween: 40,
            },
            1024: {
                slidesPerView: 3.6,
                spaceBetween: 40,
            },
            1440: {
                slidesPerView: 4.1,
                spaceBetween: 40,
            },
            1920: {
                slidesPerView: 4.7,
                spaceBetween: 40,
            }
        },
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton
        },
        scrollbar: {
            el: scrollbar,
            draggable: true,
        }
    });

    swiper.slides.forEach(function(slide, index) {
        const slideLink = slide.querySelector('a');

        slideLink.addEventListener('focus', function(e) {
            swiper.slideTo(index);
        })
    });
}

// -------------------------------------
// Hooks
// -------------------------------------

document.addEventListener('DOMContentLoaded', () => {
    const productSliders = document.querySelectorAll(PRODUCT_SLIDER_SELECTOR);

    productSliders.forEach((productSlider) => {
        initProductCarousel(productSlider);
    });
});



// $(function () {
//     $(".carousel--product-slider").each(function (index, element) {
//         var $this = $(this);

//         // Generate unique class for each feature collection slider
//         $this.addClass("product-slider-instance-" + index);

//         // Initialize feature collection slider based on the unique classes generated above.
//         var swiper = new Swiper(".product-slider-instance-" + index, {
//             // Optional parameters
//             modules: [Navigation, Pagination, Scrollbar, A11y, Keyboard],
//             slidesPerView: 1.4,
//             spaceBetween: 5,
//             centerInsufficientSlides: true,
//             observer: true,
//             observeParents: true,
//             a11y: false,
//             watchOverflow: true, // Do not turn into sliders if number of slides is less than slidesPerView.
//             grabCursor: true,

//             breakpoints: {
//                 680: {
//                     slidesPerView: 2.5,
//                     spaceBetween: 50,
//                 },
//                 1024: {
//                     slidesPerView: 3.6,
//                     spaceBetween: 72,
//                 },
//                 1920: {
//                     slidesPerView: 3.7,
//                     spaceBetween: 72,
//                 }
//             }
//         });

//         swiper.slides.forEach(function (slide, index) {
//             let slideLink = slide.querySelector('a');
//             slideLink.addEventListener('focus', function (e) {
//                 swiper.slideTo(index);
//             })
//         });
//     });
// });
